import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  IconTick,
} from "@touchtech/web-baselayer-ui";

import css from "./FailedConfirmationModal.module.css";
import useManageFailedConfirmationModal from "./hooks/useManageFailedConfirmationModal";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onClose?: () => void;
  errorMessage?: string;
  onSetErrorMessage?: (errorMessage: string) => void;
};

const FailedConfirmationModal = ({
  isOpen,
  setIsOpen,
  onClose,
  errorMessage,
  onSetErrorMessage,
}: Props) => {
  const { handleCloseModal, t } = useManageFailedConfirmationModal({
    setIsOpen,
    onClose,
    onSetErrorMessage,
  });

  return (
    <ConfirmationModal isOpen={isOpen} onClose={handleCloseModal}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Something went wrong")}
        </h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {errorMessage?.length
            ? errorMessage
            : t("The checkout was not successful. Please try again.")}
        </span>
        <Button
          className={css.okButton}
          width="full"
          sizing="lg"
          onClick={handleCloseModal}
        >
          <IconTick />
          {t("OK")}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default FailedConfirmationModal;
